import { render, staticRenderFns } from "./InvoiceApprovalList.vue?vue&type=template&id=abbd78de&"
import script from "./InvoiceApprovalList.vue?vue&type=script&lang=js&"
export * from "./InvoiceApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceApprovalList.vue?vue&type=style&index=0&id=abbd78de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports